import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import modules from "%store/index.js";

Vue.use(Vuex);

const localStoragePersistence = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    global: {
      cookiesNotificationShown: state.global.cookiesNotificationShown
    },

    security: {
      token: state.security.token
    },

    content: state.content,

    messages: {
      read: state.messages.read
    },

    videos: {
      darkMode: state.videos.darkMode
    }
  })
});

export default new Vuex.Store({
  modules,
  plugins: [localStoragePersistence.plugin]
});
